import React from "react";

//interface
import { IContentPostText } from '../../../../interfaces/information/ContentPostInformation';


const ContentPostText = ({className, contentPostText}: IContentPostText) => {
    return (
        <div className={`content-post-text-wrapper ${className}`} >
            {contentPostText}
        </div>
    );
};

export default ContentPostText